import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'

export type ToastContentProps = {
  title: string
  subtitle?: string
  body?: ReactNode
}

export const ToastContent = ({ title, subtitle, body }: ToastContentProps) => {
  return (
    <Box display="flex" flexDirection="column" mr={2}>
      <Typography variant="caption2" color="text.primary" fontWeight={600}>
        {title}
      </Typography>

      {subtitle && (
        <Typography variant="caption3" color="text.primary" mt={0.5}>
          {subtitle}
        </Typography>
      )}

      {body}
    </Box>
  )
}
